import { clsx } from 'clsx';
import { createStyle, createStyles } from 'game/lib/createStyles';
import { colors } from 'game/styles/theme';
import { PropsWithChildren } from 'react';

const activeClass = createStyle('active', {});

const classes = createStyles({
  housing: {
    background: colors.black,
    width: 70,
    height: 70,
    borderRadius: 4,
    padding: 6,
  },
  housingSmall: {
    width: 40,
    height: 50,
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    textTransform: 'uppercase',
    height: '100%',
    width: '100%',
    fontSize: 11,
    borderBottom: '2px solid #444',
    borderRadius: 4,
    '&:before, &:after': {
      content: ' ',
      position: 'absolute',
      left: 0,
      right: 0,
      borderRadius: 3,
    },
    '&:before': {
      background: '#ccc',
      top: 0,
      bottom: 0,
      border: '1px solid #92856d',
    },
    '&:after': {
      top: 2,
      bottom: 1,
      left: 2,
      right: 2,
      background: 'radial-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 1))',
      opacity: 0.3,
    },
    [`&.${activeClass}`]: {
      '&:before': {
        background: '#fcfbf5',
        borderColor: '#b3b3b3',
        boxShadow: '0 0 15px rgba(255, 255, 200, 0.75)',
      },
      '&:after': { opacity: 0.1 },
    },
  },
  hiVis: {
    borderBottom: '2px solid #9b320d',
    '&:before': {
      background: '#fcaf32',
      borderColor: '#f15a24',
      opacity: 0.9,
    },
    '&:after': {
      background: 'radial-gradient(#fcaf32, #f9540b 110%)',
      opacity: 1,
    },
    [`&.${activeClass}`]: {
      '&:before': {
        background: '#fcaf32',
        opacity: 1,
        boxShadow: '0 0 15px rgba(255, 80, 30, 1)',
        borderColor: '#f15a24',
      },
      '&:after': {
        background: 'radial-gradient(#ffcd2e, #f9540b 130%)',
        opacity: 1,
      },
    },
  },
  red: {
    borderBottom: '2px solid #610103',
    '&:before': {
      background: colors.screenError,
      borderColor: '#FC1209',
      opacity: 0.9,
    },
    '&:after': {
      background: 'radial-gradient(#FC1209, #610103 110%)',
      opacity: 1,
    },
  },
  label: {
    position: 'relative',
    zIndex: 1,
    '& > svg': { display: 'block' },
  },
});

interface ConsoleButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean,
  variant?: 'default' | 'hi-vis' | 'red',
  size?: 'small' | 'normal',
}

export const ConsoleButton: React.FC<PropsWithChildren<ConsoleButtonProps>> = ({
  active,
  variant = 'default',
  size = 'normal',
  children,
  ...buttonProps
}) => {
  return (
    <div className={clsx(classes.housing, { [classes.housingSmall]: size === 'small' })}>
      <button
        type="button"
        className={clsx(classes.button, {
          [activeClass]: active,
          [classes.hiVis]: variant === 'hi-vis',
          [classes.red]: variant === 'red',
        })}
        {...buttonProps}
      >
        <span className={classes.label}>
          {children}
        </span>
      </button>
    </div>
  );
};
